<template>

  <div class="ba-container ba-gp-1 ba-ai-baseline ba-w-100 ba-grid" v-if="website">
    <div class='ba-card'>
      <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
        <span class='ba-title'>{{ $t('ct-members-form') }}</span>
      </div>
      <hr class='ba-hr-row'>
      <div class='ba-content ba-w-100'>
        <div class="ba-w-100 ba-grid ba-gp-08">
          <div class="container-accordion-form" id="accordion">
            <div class="card">
              <div class="card-header" id="form-editing" data-toggle="collapse" :data-target="`#collapse-editing-form`" aria-expanded="true"
                  :aria-controls="`collapse-editing-form`">
                <div class="ba-flex ba-ai-center ba-jc-sb">
                  <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                  {{ $t('ct-members-form-config') }}
                </span>
                <div class="ba-flex ba-gp-06">
                  <button class="ba-btn ba-md ba-blue" @click.stop="addField">
                    <builderall-icon code='2780'></builderall-icon>
                    {{ $t('ct-add-field') }}
                  </button>
                  <span class="py-1 d-block">
                    <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                  </span>
                </div>
                </div>
              </div>
              <div :id="`collapse-editing-form`" :aria-labelledby="`form-editing`" class="collapse show" data-parent="#accordion">
                <div class="card-body">
                  <div class="ba-grid ba-gp-08">

                    <div class="ba-grid">
                      <label for="exampleInputName" class="ba-custom-label">{{ $t('ct-name') }}</label>
                      <input type="text" class="ba-input ba-md" id="exampleInputName" :value="$t('ct-name')" disabled>
                    </div>

                    <div class="ba-grid">
                      <label for="exampleInputEmail" class="ba-custom-label">{{ $t('ct-email') }}</label>
                      <input type="email" class="ba-input ba-md" id="exampleInputEmail" :value="$t('ct-email')" disabled>
                    </div>

                    <template v-if="!form_config.hidden_password">
                      <div class="ba-flex ba-w-100 ba-gp-08">
                        <div class="ba-grid ba-w-50">
                          <label for="example-input-password" class="ba-custom-label">{{ $t('ct-password') }}</label>
                          <input type="text" class="ba-input ba-md" id="example-input-password" value="********"
                            autocomplete="off" disabled>
                        </div>

                        <div class="ba-grid ba-w-50">
                          <label for="example-input-password-confirm" class="ba-custom-label">{{
                            $t('ct-password-confirm') }}</label>
                          <input type="text" class="ba-input ba-md" id="example-input-password-confirm" value="********"
                            autocomplete="off" disabled>
                        </div>
                      </div>

                    </template>

                    <draggable v-model="form_config.fields" class="form-draggable-list">
                      <div class="ba-grid ba-gp-04" v-for="(field, index) in this.form_config.fields"
                        v-if="field.type !== 'datetime'" :key="field.order">
                        <hr class="ba-hr-row">
                        <div class="ba-w-100 ba-flex ba-gp-06">
                          <div class="ba-w-100">
                            <template
                              v-if="!['checkbox', 'radio', 'select', 'textarea', 'datetime'].includes(field.type)">
                              <div class="ba-grid">
                                <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                                <input :type="field.type" class="ba-input ba-md" :id="field.label" :name="field.tag"
                                  :value="field.default_value">
                                <small v-if="field.help_text && field.help_text.length > 0"
                                  class="ba-color-black18 ba-montserrat-500 ba-text-12">{{
                                  field.help_text }}</small>
                              </div>
                            </template>

                            <template v-else-if="field.type === 'select'">
                              <div class="ba-grid">
                                <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                                <select class="ba-select" :id="field.label" :name="field.tag">
                                  <option v-for="(option, index) in field.options" :value="option.value"
                                    v-if="field.options">{{ option.name }}
                                  </option>
                                </select>
                                <small v-if="field.help_text && field.help_text.length > 0"
                                  class="ba-color-black18 ba-montserrat-500 ba-text-12">{{
                                  field.help_text }}</small>
                              </div>
                            </template>

                            <template v-else-if="field.type === 'textarea'">
                              <div class="ba-grid">
                                <label :for="field.label" class="ba-custom-label">{{ field.label }}</label>
                                <textarea class="ba-textarea" :id="field.label" :name="field.tag"
                                  rows="3">{{ field.default_value }}</textarea>
                                <small v-if="field.help_text && field.help_text.length > 0"
                                  class="ba-color-black18 ba-montserrat-500 ba-text-12">{{
                                  field.help_text }}</small>
                              </div>
                            </template>

                            <template v-else-if="['checkbox', 'radio'].includes(field.type)">
                              <div class="ba-grid">
                                <label class="ba-custom-label">{{ field.label }}</label>
                                <div class="form-check" v-for="(option, index) in field.options" :key="index"
                                  v-if="field.options">
                                  <input class="form-check-input" :type="field.type" :name="field.tag"
                                    :id="option.value" :value="option.value">
                                  <label class="form-check-label" :for="option.value">
                                    {{ option.name }}
                                  </label>
                                </div>
                                <small v-if="field.help_text && field.help_text.length > 0"
                                  class="ba-color-black18 ba-montserrat-500 ba-text-12">{{
                                  field.help_text }}</small>
                              </div>
                            </template>
                          </div>

                          <div class="ba-flex ba-ai-center ba-gp-06">
                            <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="editField(field)"
                              ba-tooltip-position="top" :ba-tooltipo="$t('ct-edit')">
                              <builderall-icon code='edit' />
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded'
                              @click.prevent="deleteField(field, index)" ba-tooltip-position="top"
                              :ba-tooltipo="$t('ct-delete-field')">
                              <builderall-icon code='trash' />
                            </button>
                          </div>
                        </div>
                        <hr>
                      </div>
                    </draggable>
                    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                      <button type="button" @click.prevent="save()" class="ba-btn ba-md ba-blue">
                        {{ $t('ct-save') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container-accordion-form" id="accordion">
            <div class="card">
              <div class="card-header collapsed" id="themeSettings" data-toggle="collapse"
                data-target="#collapseThemeSettings" aria-expanded="false" aria-controls="collapseThemeSettings">
                <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                  {{ $t('ct-members-form-theme') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
              <div id="collapseThemeSettings" class="collapse" aria-labelledby="themeSettings" data-parent="#accordion">
                <div class="card-body">
                  <div class="ba-grid ba-gp-08">
                    <div class="ba-flex ba-w-100 ba-ai-start ba-gp-08">


                      <div class="ba-grid ba-w-50 ba-gp-08">
                        <div class="ba-grid">
                          <label for="form-theme" class="ba-custom-label">{{ $t('ct-theme-type') }}</label>
                          <select class="ba-select ba-md" id="form-theme" name="form-theme" v-model="form_config.theme">
                            <option v-for="(theme, index) in form_themes" :value="theme.value" :key="index"
                              v-if="form_themes">{{
                              $t(`ct-${theme.name}`) }}
                            </option>
                          </select>
                        </div>

                        <div class="ba-grid" v-if="form_config.theme !== 'default'">
                          <label for="form-style" class="ba-custom-label">{{ $t('ct-theme-style') }}</label>
                          <select class="ba-select ba-md" id="form-style" name="form-style"
                            v-model="form_config.config.style">
                            <option v-for="(style, index) in form_theme_style" :value="style" :key="index">{{
                              $t(`ct-${style}`)
                              }}
                            </option>
                          </select>
                        </div>

                        <div class="ba-grid">
                          <label for="background-color" class="ba-custom-label">{{ $t('ct-bg-color') }}</label>
                          <div class="ba-flex ba-ai-center ba-gp-08">
                            <label class="ba-flex ba-ai-center ba-gp-08">
                              <input type="color" id="background-color" name="background-color"
                                v-model="form_config.config.background.color" required>
                          
                              <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" style="width: 15px !important;"/>
                            </label>
                            <div class="hex-input" v-if="form_config.config.background.color != ''">
                              {{ form_config.config.background.color }}
                            </div>
                            <div>
                              <button class="ba-btn ba-btn-trash ba-sm ba-rounded"
                                v-show="form_config.config.background.color"
                                v-on:click.prevent="form_config.config.background.color = ''">
                                <builderall-icon code='trash' />
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="ba-grid ba-w-100">
                          <div class="shere-image-container">
                            <label class="ba-custom-label">{{   $t('ct-background-img') }}</label>

                            <div class="shere-image-preview">
                              <div class="share-image" :style="`background-image: url('${form_config.config.background.image}');`" v-if="form_config.config.background.image" />
                              <div class="ba-w-100" v-else>
                                <div class="shere-empty" @click="getImages">
                                  <builderall-icon code='9da0'></builderall-icon>
                                </div>
                              </div>
                            </div>

                            <div class="ba-w-100 ba-mg-y-1" v-if="form_config.config.background.image">
                              <div class="ba-flex ba-ai-center ba-jc-center ba-gp-06">
                                <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="getImages">
                                  <builderall-icon code='edit' />
                                </button>
                                <button class='ba-btn ba-btn-trash ba-sm ba-rounded'
                                  v-show="form_config.config.background.image" @click.prevent="removeImage">
                                  <builderall-icon code='trash' />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="form-group row">
                          <label for="background-color" class="col-sm-4 col-form-label">{{
                            $t('ct-background-img')
                            }}</label>
                          <div class="shere-image-container col-sm-8">
                            <div class="shere-image-options">
                              <div class="shere-image-btns">
                                <button class="btn btn-outline-primary btn-choose" @click.prevent="getImages">{{
                                  $t('ct-choose', 'Choose')
                                  }}
                                </button>
                                <button class="btn btn-outline-danger" v-show="form_config.config.background.image"
                                  v-on:click.prevent="removeImage">
                                  <font-awesome-icon :icon="['far', 'trash-alt']" class="font-awesome-icon danger" />
                                </button>
                              </div>
                            </div>
                            <div class="shere-image-preview" v-if="form_config.config.background.image">
                              <div class="share-image"
                                :style="`background-image: url('${form_config.config.background.image}');`"></div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                      <div class="ba-grid ba-w-50">
                        <div class="ba-grid" v-if="form_config.theme">
                          <label for="form-style" class="ba-custom-label">{{ $t('ct-preview') }}</label>
                          <div class="ba-w-100">
                            <div class="preview-theme">
                              <img v-if="form_config.theme !== 'default'"
                                :src="`/static/images/members-form-themes/${form_config.theme}-${form_config.config.style}.png`" />
                              <img v-else :src="`/static/images/members-form-themes/default.png`" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="ba-grid ba-w-50" v-if="form_config.config.background.image">
                      <label class="ba-custom-label">{{ $t('ct-background-image-repeat') }}</label>
                      <div class="form-check form-check-inline" v-for="(type, index) in background_repeat">
                        <input type="radio" class="form-check-input" :id="`background-repeat-type-${type}`"
                          name="background-repeat-type" :value="type" v-model="form_config.config.background.repeat">
                        <label :for="`background-repeat-type-${type}`" class="form-check-label">{{
                          $t(`ct-bg-config-repeat-${type}`)
                          }}</label>
                      </div>
                    </div>

                    <div class="ba-grid ba-w-50" v-if="form_config.config.background.image">
                      <label class="ba-custom-label">{{ $t('ct-background-image-size') }}</label>

                      <div class="form-check form-check-inline" v-for="(type, index) in background_size">
                        <input type="radio" class="form-check-input" :id="`background-size-type-${type}`"
                          name="background-size-type" :value="type" v-model="form_config.config.background.size">
                        <label :for="`background-size-type-${type}`" class="form-check-label">{{
                          $t(`ct-bg-config-size-${type.split('%').join('').replace(' ', '-')}`)
                          }}</label>
                      </div>
                    </div>

                    <div class="ba-grid">
                      <label class="ba-custom-label">{{ $t('ct-hide-register-btn') }}</label>
                      <div class="ba-flex">
                        <div class="form-check form-check-inline">
                          <input type="radio" class="form-check-input" id="hide-register-btn-no"
                            name="hide-register-btn" value="0" v-model.number="form_config.config.hide_register_btn">
                          <label for="hide-register-btn-no" class="form-check-label">{{ $t('ct-no') }}</label>
                        </div>

                        <div class="form-check form-check-inline">
                          <input type="radio" class="form-check-input" id="hide-register-btn-yes"
                            name="hide-register-btn" value="1" v-model.number="form_config.config.hide_register_btn">
                          <label for="hide-register-btn-yes" class="form-check-label">{{ $t('ct-yes') }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="ba-grid">
                      <label for="access-denied-msg" class="ba-custom-label">{{ $t('ct-access-denied-msg') }}</label>
                      <input type="text" name="access-denied-msg" id="access-denied-msg" class="ba-input ba-md"
                        v-model="form_config.config.access_denied.message" />
                    </div>

                    <div class="ba-grid">
                      <label class="ba-custom-label">{{ $t('ct-access-denied-btn-enable') }}</label>
                      <div class="ba-flex">
                        <div class="form-check form-check-inline">
                          <input type="radio" class="form-check-input" id="access-denied-btn-yes"
                            name="access-denied-btn" value="1"
                            v-model.number="form_config.config.access_denied.btn.enable">
                          <label for="access-denied-btn-yes" class="form-check-label">{{ $t('ct-yes') }}</label>
                        </div>

                        <div class="form-check form-check-inline">
                          <input type="radio" class="form-check-input" id="access-denied-btn-no"
                            name="access-denied-btn" value="0"
                            v-model.number="form_config.config.access_denied.btn.enable">
                          <label for="access-denied-btn-no" class="form-check-label">{{ $t('ct-no') }}</label>
                        </div>
                      </div>
                    </div>

                    <template v-if="form_config.config.access_denied.btn.enable">
                      <div class="ba-grid">
                        <label for="access-denied-btn-text" class="ba-custom-label">{{ $t('ct-access-denied-btn-text')
                          }}</label>
                        <input type="text" class="ba-input ba-md" id="access-denied-btn-text" name="access-denied-btn-text"
                          v-model="form_config.config.access_denied.btn.text">
                      </div>

                      <div class="ba-grid">
                        <label class="ba-custom-label">{{ $t('ct-access-denied-btn-position') }}</label>
                        <div class="ba-flex ba-ai-center ba-gp-06">
                          <div class="form-check" v-for="(pos, index) in position_button" :key="pos">
                            <input type="radio" class="form-check-input" name="access-denied-btn-position"
                              :id="`access-denied-btn-position-${pos}`" :value="pos"
                              v-model="form_config.config.access_denied.btn.position">
                            <label :for="`access-denied-btn-position-${pos}`" class="form-check-label">{{
                              $t(`ct-access-link-btn-${pos}`) }}</label>
                          </div>
                        </div>

                      </div>

                      <div class="ba-grid">
                        <label class="ba-custom-label">{{ $t('ct-access-denied-type-link') }}</label>
                        <div class="ba-flex ba-ai-center ba-gp-06">
                          <div class="form-check">
                            <input type="radio" class="form-check-input" id="access-denied-type-link-home"
                              name="access-denied-type-link" value="home"
                              v-model="form_config.config.access_denied.link.type">
                            <label for="access-denied-type-link-home" class="form-check-label">{{
                              $t('ct-access-link-home') }}</label>
                          </div>

                          <div class="form-check">
                            <input type="radio" class="form-check-input" id="access-denied-type-link-web"
                              name="access-denied-type-link" value="web"
                              v-model="form_config.config.access_denied.link.type">
                            <label for="access-denied-type-link-web" class="form-check-label">{{
                              $t('ct-access-link-web')
                              }}</label>
                          </div>

                          <div class="form-check">
                            <input type="radio" class="form-check-input" id="access-denied-type-link-page"
                              name="access-denied-type-linkn" value="page"
                              v-model="form_config.config.access_denied.link.type">
                            <label for="access-denied-type-link-page" class="form-check-label">{{
                              $t('ct-access-link-page') }}</label>
                          </div>
                        </div>
                      </div>

                      <div class="ba-grid" v-if="form_config.config.access_denied.link.type === 'web'">
                        <label for="access-denied-value-link-web" class="ba-custom-label">{{
                          $t('ct-access-denied-value-link-web') }}</label>
                        <input type="text" class="ba-input ba-md" id="access-denied-value-link-web"
                          name="access-denied-value-link-web" required
                          v-model="form_config.config.access_denied.link.value">
                      </div>

                      <div class="ba-grid" v-else-if="form_config.config.access_denied.link.type === 'page'">
                        <label for="access-denied-value-link-web" class="ba-custom-label">{{
                          $t('ct-access-denied-value-link-page') }}</label>

                        <select type="text" class="ba-select" id="access-denied-value-link-page"
                          name="access-denied-value-link-page" required
                          v-model.number="form_config.config.access_denied.link.page_id">
                          <option value="" disabled>{{ $t('ct-access-denied-value-link-page') }}</option>
                          <option :value="page.page_id" v-for="(page, i) in website_pages" :key="i">{{ page.page_name }}
                          </option>
                        </select>
                      </div>

                    </template>
                  </div>
                  <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                    <button type="button" @click.prevent="save()" class="ba-btn ba-md ba-blue">
                      {{ $t('ct-save') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container-accordion-form" id="accordion">
            <div class="card">
              <div class="card-header collapsed" id="headingSenders" data-toggle="collapse"
                data-target="#collapseSenders" aria-expanded="false" aria-controls="collapseSenders">
                <span class="py-1 d-block ba-montserrat-600 ba-text-14">
                  {{ $t('ct-website-senders') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
              <div id="collapseSenders" class="collapse" aria-labelledby="headingSenders" data-parent="#accordion">

                <div class="card-body">
                  <div class="ba-grid ba-gp-08">


                    <div class="ba-grid">
                      <label for="senders-website" class="ba-custom-label">{{ $t('ct-sender-other-settings') }}</label>
                      <select class="ba-select ba-md" id="senders-website" name="senders-website"
                        v-model="form_config.senders.other_settings">
                        <option value="0">no-reply@builderall.com</option>
                        <option v-if="mailingboss_user && mailingboss_user.sendersList"
                          v-for="(sender, index) in mailingboss_user.sendersList" :value="sender" :key="index">{{ sender
                          }}
                        </option>
                      </select>
                      <small class="ba-montserrat-500 ba-text-12 ba-color-black18">{{
                        $t('ct-sender-other-settings-help') }}</small>

                    </div>

                    <div class="ba-grid">
                      <label for="senders-integrations" class="ba-custom-label">{{ $t('ct-sender-integrations')
                        }}</label>
                      <select class="ba-select ba-md" id="senders-integrations" name="senders-website"
                        v-model="form_config.senders.integrations">
                        <option value="0">no-reply@builderall.com</option>
                        <option v-if="mailingboss_user && mailingboss_user.sendersList"
                          v-for="(sender, index) in mailingboss_user.sendersList" :value="sender" :key="index">{{ sender
                          }}
                        </option>
                      </select>
                      <small class="ba-montserrat-500 ba-text-12 ba-color-black18">{{ $t('ct-sender-integrations-help')
                        }}</small>

                    </div>
                    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                      <button type="button" @click.prevent="save()" class="ba-btn ba-md ba-blue">
                        {{ $t('ct-save') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <!-- General Form Settings - Begin -->

          <div class="container-accordion-form" id="accordion">
            <div class="card">
              <div class="card-header collapsed" id="GeneralSettings" data-toggle="collapse"
                data-target="#collapseGeneralSettings" aria-controls="collapseGeneralSettings" aria-expanded="false">
                <span class="py-1 d-block ba-montserrat-600 ba-text-14">
                  {{ $t('ct-members-form-general') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon" />
                </span>
              </div>
              <div id="collapseGeneralSettings" class="collapse" aria-labelledby="GeneralSettings"
                data-parent="#accordion">
                <div class="card-body">
                  <div class="ba-grid ba-gp-08">
                    <div class="ba-grid">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form_config.hidden_password"
                          id="form-members-password-hidden">
                        <label for="form-members-password-hidden"
                          class="form-check-label ba-text-14 ba-montserrat-500">{{ $t('ct-form-members-hidden-password')
                          }}</label>
                      </div>
                      <small class="ba-text-12 ba-montserrat-500 ba-color-black18">{{
                        $t('ct-form-members-hidden-password-obs') }}</small>
                    </div>

                    <template v-if="!loading_campaigns">
                      <div class="ba-grid ba-gp-02">
                        <label for="campaign" class="ba-custom-label">{{ $t('ct-social-proof') }}</label>
                        <select name="campaign" id="campaign" class="ba-select ba-md"
                          v-model="form_config.socialproof_campaign_id">
                          <option value="0" selected>{{ $t('ct-social-proof-select') }}</option>
                          <option v-if="campaigns" v-for="(campaign, index) in campaigns" :value="campaign.id">
                            {{ campaign.name }}
                          </option>
                        </select>
                        <small class="ba-text-12 ba-montserrat-500 ba-color-black18">{{ $t('ct-social-proof-obs')
                          }}</small>
                      </div>

                      <div class="ba-w-100 ba-flex ba-jc-fe ba-gp-1">
                        <a :href="`${officeDomain}/br/office/new-social-proof`" target="_blank"
                          class="ba-btn ba-lg ba-blue">
                          {{ $t('ct-goto-social-proof') }}
                        </a>
                        <button type="button" @click.prevent="save()" class="ba-btn ba-md ba-blue">
                          {{ $t('ct-save') }}
                        </button>
                      </div>

                    </template>
                    <div class="form-group text-center" v-else>
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <sweet-modal ref="addField" width="60vw" hide-close-button>

      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t(`ct-field-action-${this.newField.action}`) }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closeFielad">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1">
        <div class="ba-grid ba-gp-08" ref="form-add-field">
          <div class="ba-flex ba-w-100">
            <div class="ba-grid  ba-w-100">
              <label class="ba-custom-label">{{ $t('ct-type') }}</label>
              <div class="ba-flex">
                <div class="form-check form-check-inline" v-for="(type, index) in types_fields">
                  <input class="form-check-input" type="radio" v-model="newField.type" :id="`input-type-${type}`"
                    required="required" @keydown="errors.clear('newField.type')"
                    :class="{ 'is-invalid': errors.has('newField.type') }" :value="type">
                  <label class="form-check-label" :for="`input-type-${type}`">{{ $t(`ct-${type}`) }}</label>
                </div>
              </div>
              <span v-if="errors.has('newField.type')" class="invalid-feedback"
                v-text="errors.get('newField.type')"></span>
            </div>

            <div class="ba-grid">
              <label class="ba-custom-label">{{ $t('ct-required') }}</label>
              <div class="ba-flex">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="newField.required" id="input-required-yes"
                    value="yes">
                  <label class="form-check-label" for="input-required-yes">{{ $t(`ct-yes`) }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" v-model="newField.required" id="input-required-no"
                    value="no">
                  <label class="form-check-label" for="input-required-no">{{ $t(`ct-no`) }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="ba-flex ba-w-100 ba-gp-08">
            <div class="ba-box-input ba-w-100">
              <label for="tag" class="ba-custom-label">{{ $t('ct-tag') }}</label>
              <input type="text" v-model="newField.tag" id="tag" class="ba-input ba-md" name="tag" required="required"
                @keydown="errors.clear('newField.tag')" :class="{ 'ba-error': errors.has('newField.tag') }">
              <span v-if="errors.has('newField.tag')" class="ba-validation-text"
                v-text="errors.get('newField.tag')"></span>
            </div>

            <div class="ba-box-input ba-w-100">
              <label for="label" class="ba-custom-label">{{ $t('ct-label') }}</label>
              <input type="text" v-model="newField.label" class="ba-input ba-md" id="label" name="label" required="required"
                @keydown="errors.clear('newField.label')" :class="{ 'ba-error': errors.has('newField.label') }">
              <span v-if="errors.has('newField.label')" class="ba-validation-text"
                v-text="errors.get('newField.label')"></span>
            </div>

            <div class="ba-grid ba-w-100">
              <label for="help-text" class="ba-custom-label">{{ $t('ct-help-text') }}</label>
              <input type="text" v-model="newField.help_text" id="help-Text" class="ba-input ba-md" name="help_text">
            </div>
          </div>

          <div class="ba-w-100 ba-flex ba-jc-fe"
            v-if="newField.type === 'checkbox' || newField.type === 'radio' || newField.type === 'select'">
            <button class="ba-btn ba-md ba-blue" @click="openOptionPopup"><builderall-icon
                code='2780'></builderall-icon></button>
          </div>
          <div class="ba-w-100"
            v-if="newField.type === 'checkbox' || newField.type === 'radio' || newField.type === 'select'">
            <div class="ba-grid ba-gp-06">
              <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;">
                <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
                  <span class="ba-montserrat-600" style="width: 150px;">{{ $t('ct-name') }}</span>
                  <span class="ba-montserrat-600">{{ $t('ct-value') }}</span>
                  <span class="ba-montserrat-600"></span>
                </div>
              </div>
              <div class="ba-card ba-w-100 ba-no-shadow " v-for="(option, index) in newField.options" :key="index"
                style="height: 50px;">
                <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
                  <span class="ba-montserrat-600" style="width: 150px;"> {{ option.name }} </span>
                  <span class="ba-montserrat-600">{{ option.value }}</span>
                  <div>
                    <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="newField.options.splice(index, 1)"
                      ba-tooltip-position="top" :ba-tooltipo="$t('ct-delete')">
                      <builderall-icon code='trash' />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <table class="table table-borderless">
              <thead>
                <th>{{ $t('ct-value') }}</th>
                <th>{{ $t('ct-name') }}</th>
                <th>
                  
                </th>
              </thead>
              <tr v-for="(option, index) in newField.options" :key="index">
                <td>{{ option.value }}</td>
                <td>{{ option.name }}</td>
                <td>
                  <font-awesome-icon :icon="['far', 'trash-alt']"
                    v-tooltip="{ content: $t('ct-option-delete'), class: 'tooltip-custom' }" class="danger"
                    @click="newField.options.splice(index, 1)" />
                </td>
              </tr>
            </table> -->
          </div>
        </div>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="closeFielad">{{
          $t('ct-cancel') }}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="saveField">{{ $t('ct-save')
          }}</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="option" width="40vw" hide-close-button>

      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-option') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="$refs.option.close()">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1">
        <form ref="form-add-option">
          <div class="ba-grid ba-gp-08">
            <div class="ba-box-input">
              <label for="name" class="ba-custom-label">{{ $t('ct-name') }}</label>
              <input type="text" class="ba-input ba-md" name="name" id="name" ref="form_option_name"
                :class="{ 'ba-error': errors.has('newOption.name') }" @keydown="errors.clear('newOption.name')"
                required>
              <span v-if="errors.has('newOption.name')" class="ba-validation-text"
                v-text="errors.get('newOption.name')"></span>
            </div>
            <div class="ba-box-input">
              <label for="value" class="ba-custom-label">{{ $t('ct-value') }}</label>
              <input type="text" class="ba-input ba-md" name="value" id="value" ref="form_option_value"
                :class="{ 'ba-error': errors.has('newOption.value') }" @keydown="errors.clear('newOption.value')"
                required>
              <span v-if="errors.has('newOption.value')" class="ba-validation-text"
                v-text="errors.get('newOption.value')"></span>
            </div>
          </div>
        </form>
      </div>
      <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="$refs.option.close()">{{
          $t('ct-cancel')}}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="addOption">{{ $t('ct-save')
          }}</button>
      </div>

    </sweet-modal>

    <social-proof-campaign-component ref="social-proof-campaign" :website_id="website.encrypted_id"
      @updateAllCampaigns="getAllCampaigns"></social-proof-campaign-component>
  </div>
</template>

<script>
import NavComponent from '../layout/nav/Nav.vue';
import BreadcrumbComponent from './../components/Breadcrumb';
import ModalDeleteComponent from './../components/ModalDelete';
import SiteSidebarComponent from './../layout/site/SiteSidebar';
import SocialProofCampaignComponent from './../layout/site/SocialProofCampaign';
import FileManager from './../../general/FilesManager/FileManager';
import { SweetModal } from 'sweet-modal-vue';
import Errors from '../../../js/base/Errors';
import draggable from 'vuedraggable';

import { edit, getAll } from './../../../js/services/restrictArea/formFields';
import { get as getFormTheme } from './../../../js/services/restrictArea/formTheme';
import { getUserInfoBasic } from '../../../js/services/integrations-internas/mailingboss';
import { getAllCampaigns } from '../../../js/services/integrations-internas/socialProof';
import { deepMerge } from "../../../js/services/utils";
import { getWebsiteLink } from "../../../js/services/editor/link";

export default {
  name: 'Emails',
  components: {
    NavComponent,
    BreadcrumbComponent,
    ModalDeleteComponent,
    SiteSidebarComponent,
    SocialProofCampaignComponent,
    SweetModal,
    draggable,
    FileManager
  },
  data() {
    return {
      errors: new Errors(),
      loading_campaigns: false,
      website: { id: '', encrypted_id: '' },
      website_pages: [],
      emails_themes: {},
      mailingboss_user: {},
      campaigns: [],
      image: {
        show: false,
        page: null
      },
      form_themes: [
        {
          name: 'default',
          value: 'default'
        },

        {
          name: 'three-tabs',
          value: 'three-tabs'
        },

        {
          name: 'two-tabs',
          value: 'two-tabs'
        },

        {
          name: 'two-columns',
          value: 'two-columns'
        },

        {
          name: 'in-block',
          value: 'in-block'
        }
      ],
      form_theme_style: ['light', 'dark'],
      background_repeat: ['no-repeat', 'repeat', 'repeat-x', 'repeat-y', 'space', 'round'],
      background_size: ['auto', '50%', '100% 100%', 'cover', 'contain'],
      position_button: ['top', 'left', 'bottom', 'right'],
      form_config: {
        theme: '',
        automatic_email_id: null,
        hidden_password: 0,
        socialproof_campaign_id: 0,
        config: {
          style: 'light',
          hide_register_btn: 0,
          access_denied: {
            message: this.$t('ct-restrict-area-not-have-permission'),
            btn: {
              enable: 1,
              text: this.$t('ct-home'),
              position: 'right'
            },
            link: {
              type: 'home',
              value: null,
              page_id: null
            }
          },
          background: {
            image: '',
            color: '',
            repeat: 'repeat',
            size: 'contain'
          }
        },
        senders: {
          other_settings: '0', // no-replay@builderall.com
          integrations: '0' // no-replay@builderall.com
        },
        fields: [],
        website: { id: '', encrypted_id: '', websiteForm: {} }
      },
      types_fields: ['text', 'textarea', 'password', 'checkbox', 'radio', 'select', 'date'],
      newField: {
        action: 'create',
        'tag': '',
        'label': '',
        'required': 'yes',
        'help_text': null,
        'visibility': 'visible',
        'type': 'text',
        'options': [],
        order: false
      },
      officeDomain: ''
    };
  },

  methods: {
    clearString(string) {
      return string.toUpperCase().trim();
    },

    validate() {
      this.errors.validateFormat(
        this.$refs['form-add-field'],
        'newField'
      );

      if ((this.form_config.fields.find(field => this.clearString(field.tag) === this.clearString(this.newField.tag) && field.order !== this.newField.order)) || ['NAME', 'EMAIL', 'PASSWORD', 'PASSWORD_CONFIRMATION'].includes(this.clearString(this.newField.tag)))
        this.errors.add('tag', 'validation-already-been-taken', 'newField');

      if (this.form_config.fields.find(field => this.clearString(field.label) === this.clearString(this.newField.label) && field.order !== this.newField.order))
        this.errors.add('label', 'validation-already-been-taken', 'newField');

      return this.errors.any();
    },

    addField() {
      this.$refs.addField.open();
    },

    openPopupField(val, field) {
      this.$refs[val].open();
    },

    openOptionPopup() {
      this.$refs.form_option_name.value = '';
      this.$refs.form_option_value.value = '';
      this.$refs.option.open();
    },

    emptyNew() {
      this.newField = {
        action: 'create',
        'tag': '',
        'label': '',
        'required': 'yes',
        'help_text': null,
        'visibility': 'visible',
        'type': 'text',
        'options': [],
        order: false
      };

      this.emptyOption();
    },

    emptyOption() {
      this.$refs.form_option_name.value = '';
      this.$refs.form_option_value.value = '';
    },

    addOption() {
      this.errors.validateFormat(
        this.$refs['form-add-option'],
        'newOption'
      );

      if (!this.errors.any()) {
        let obj = {
          name: this.$refs.form_option_name.value,
          value: this.$refs.form_option_value.value
        };

        this.newField.options.push(Object.assign({}, obj));
        this.$refs.option.close();

        this.emptyOption();
      }
    },

    saveField() {
      if (!this.validate()) {
        if (this.newField.action === 'create') {
          this.newField.order = this.form_config.fields.length + 1;
          this.form_config.fields.push(this.newField);
        }

        this.$refs.addField.close();

        this.emptyNew();
      }
    },

    closeFielad() {
      this.$refs.addField.close();
      this.emptyNew();
      this.errors.clear();
    },

    editField(field) {
      this.newField = field;
      this.newField.required = field.required === 1 || field.required === 'yes' ? 'yes' : 'no';
      this.newField.action = 'update';
      this.$refs.addField.open();
    },

    deleteField(field, index) {
      this.form_config.fields.splice(index, 1);
    },

    save() {
      this.$loading.show();

      this.form_config.fields.map((field, index) => {
        field.order = index + 1;
      });

      this.form_config.websiteForm = this.website.websiteForm;

      edit(this.form_config)
        .then(response => {
          if (response.data.success)
            this.$snotify.success(this.$t('ct-saved-successfully'));
          else this.$snotify.error(this.$t('ct-error-saving'));
        })
        .catch(() => {
          this.$snotify.error(this.$t('ct-error-saving'));
        })
        .finally(() => {
          this.$loading.hide();
        });
    },

    saveImage(image) {
      if (image) {
        this.form_config.config.background.image = image;

        this.canRemove = true;

        this.closeImage();
      }
    },

    removeImage() {
      this.form_config.config.background.image = '';
    },

    getImages() {
      this.image.show = true;

      let values = {
        action: 'open',
        type: 'Images',
        save: this.saveImage,
        close: this.closeImage
      };

      this.$root.$emit('fileMananger', values);
    },

    closeImage() {
      let values = {
        action: 'close',
        type: 'Images',
        save: this.saveImage,
        close: this.closeImage
      };

      this.$root.$emit('fileMananger', values);

      this.image = {
        show: false
      };
    },

    createCampaign() {
      this.$refs['social-proof-campaign'].open();
    },

    getAllCampaigns() {
      this.loading_campaigns = true;

      getAllCampaigns()
        .then(res => {
          if (!res.data.error && res.data.data)
            this.campaigns = res.data.data.data.filter(campaign => campaign.type === 'members_area');
        })
        .catch(error => {
          console.error('error', error);
        })
        .finally(() => this.loading_campaigns = false);
    }
  },
  async created() {
    this.website.encrypted_id = this.$route.params.website_id;
    this.form_config.website.encrypted_id = this.$route.params.website_id;
    this.officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';

    getAll(this.website.encrypted_id)
      .then(response => {
        if (response.data.success)
          this.form_config.fields = response.data.data;
      });

    await getFormTheme(this.website.encrypted_id)
      .then(response => {
        if (response.data.success && response.data.data && response.data.data.length > 0) {
          this.website.websiteForm = response.data.data[0];
          this.form_config.theme = this.website.websiteForm.theme;

          this.form_config.hidden_password = this.website.websiteForm.hidden_password;
          if (this.website.websiteForm.socialproof_campaign_id)
            this.form_config.socialproof_campaign_id = this.website.websiteForm.socialproof_campaign_id;

          this.form_config.config = deepMerge(this.form_config.config, this.website.websiteForm.config);

          this.form_config.senders = { ...this.form_config.senders, ...this.website.websiteForm.senders };

          if (this.form_config.config && this.form_config.config.background && !this.form_config.config.background.repeat)
            this.form_config.config.background.repeat = 'repeat';

          if (this.form_config.config && this.form_config.config.background && !this.form_config.config.background.size)
            this.form_config.config.background.size = 'contain';
        } else {
          this.form_config.theme = 'default';
          this.form_config.config.style = 'light';
        }
      });

    getUserInfoBasic()
      .then(res => {
        if (res.data.success)
          this.mailingboss_user = res.data.data;
      })
      .catch(error => console.log(error));

    getWebsiteLink(this.website.encrypted_id)
      .then(({ data }) => {
        const pages = data.layouts.length > 0 ? data.layouts[0].pages : [];

        pages.forEach(page => {
          this.website_pages.push({
            page_id: page.id,
            page_name: page.name
          });
        });
      });

    this.$loading.hide();

    this.getAllCampaigns();
  },

  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.btn-group .btn {
  padding: .375rem .75rem;
}

.form-draggable-list .form-group {
  cursor: pointer;

  .form-control,
  .form-check-input {
    pointer-events: none;
  }
}

.btn-outline-danger {
  font-size: 12px;
}

.preview-theme {
  text-align: center;

  img {
    max-width: 100%;
    max-height: 400px;
  }
}
#background-color {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 30px;
  height: 30px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
#background-color::-webkit-color-swatch {
  border-radius: 4px;
  border: none;
}
#background-color::-moz-color-swatch {
  border-radius: 4px;
  border: none;
}
.hex-input {
  background-color: #EFF2F8;
  color: #425E7D80;
  font-weight: 500;
  font-size: 12px;
  padding: 14px;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/FormMembers.vue